import {
  INSTAGRAM,
  INSTAGRAM_LABEL,
  MAX_MESSENGER,
  MAX_MESSENGER_LABEL,
  TELEGRAM,
  TELEGRAM_LABEL,
  TELEGRAM_PERSONAL,
  TELEGRAM_PERSONAL_LABEL,
  VK,
  VK_LABEL,
} from '@app/constants';

import {
  ConnectAuthArchetype,
  type ConnectChannelConfig,
} from '@pages/Integrations/IntegrationsList/components/ConnectIntegrationModal/types';

/**
 * Каналы, которые подключаются через единое окно (task/10730, task/10731).
 * Avito отсутствует намеренно: канала в CRM не существует.
 */
export const CONNECT_CHANNEL_CONFIGS: Record<string, ConnectChannelConfig> = {
  [TELEGRAM_PERSONAL]: {
    archetype: ConnectAuthArchetype.QrSession,
    title: TELEGRAM_PERSONAL_LABEL,
  },
  [MAX_MESSENGER]: {
    archetype: ConnectAuthArchetype.QrSession,
    title: MAX_MESSENGER_LABEL,
  },
  [TELEGRAM]: {
    archetype: ConnectAuthArchetype.Token,
    title: TELEGRAM_LABEL,
  },
  [VK]: {
    archetype: ConnectAuthArchetype.Provider,
    title: VK_LABEL,
  },
  [INSTAGRAM]: {
    archetype: ConnectAuthArchetype.Provider,
    title: INSTAGRAM_LABEL,
    hasEmbeddedLogin: true,
  },
};

/** Инструкция сканирования — по шагам, тексты из согласованных макетов */
export const QR_INSTRUCTIONS: Record<string, string[]> = {
  [TELEGRAM_PERSONAL]: [
    'Откройте Telegram на телефоне',
    'Настройки → Устройства',
    'Нажмите «Подключить устройство»',
    'Наведите камеру на этот QR-код',
  ],
  [MAX_MESSENGER]: [
    'Откройте MAX на телефоне',
    'Настройки → Устройства',
    'Нажмите «Привязать устройство»',
    'Наведите камеру на этот QR-код',
  ],
};

/** Куда приходит код при входе по номеру */
export const CODE_DESTINATION: Record<string, string> = {
  [TELEGRAM_PERSONAL]: 'Код отправлен в приложение Telegram',
  [MAX_MESSENGER]: 'Код отправлен по SMS',
};

export const QR_POLLING_INTERVAL_MS = 25_000;
/** Две попытки GetQr с запасом на наблюдавшийся на проде ответ за 13 секунд. */
export const QR_WAIT_LIMIT_MS = 60_000;

/**
 * Сколько ждём подтверждения после того, как код отсканирован. Штатно шаг
 * сменяется за секунды; минута — запас с большим избытком, за которым уже
 * честнее сказать человеку, что вход не завершился, чем крутить спиннер
 * бесконечно (issue/11036).
 */
export const SCANNED_WAIT_LIMIT_MS = 60_000;
export const RESEND_COOLDOWN_SECONDS = 60;

/**
 * Длина кода входа по номеру. CRM не передаёт фронту длину кода от шлюза,
 * поэтому её задаёт канал. MAX присылает 6 цифр (issue/11777).
 */
export const DEFAULT_CODE_LENGTH = 5;
export const CODE_LENGTH_BY_CHANNEL: Record<string, number> = {
  [TELEGRAM_PERSONAL]: DEFAULT_CODE_LENGTH,
  [MAX_MESSENGER]: 6,
};

/** Окно провайдера (ВКонтакте, Instagram): размер и период опроса closed */
export const PROVIDER_WINDOW_FEATURES = 'popup,width=560,height=720';
export const PROVIDER_WINDOW_CHECK_INTERVAL_MS = 1000;
/** Окно настроек канала у провайдера (шестерёнка у подключённой интеграции) */
export const PROVIDER_SETTINGS_WINDOW_FEATURES = 'popup,width=900,height=900';

/**
 * Долгое ожидание (task/10903). У MAX и Telegram Personal сначала поднимается
 * воркер, потом выпускается QR. Немой скелетон люди читают как «подвисло» и
 * закрывают окно, обрывая процесс.
 */
export const LONG_WAIT_HINT_DELAY_MS = 5_000;
export const LONG_WAIT_HINT_ROTATE_MS = 6_000;
export const LONG_WAIT_WARNING =
  'Не закрывайте окно — подключение ещё выполняется.';

/**
 * Подсказки — заготовленные строки, а не реальные этапы шлюза: точных стадий
 * CRM не знает, поэтому формулировки честные и без процентов.
 */
export const LONG_WAIT_HINTS_AUTH: string[] = [
  'Создаём подключение к каналу',
  'Ждём ответа шлюза',
  'Готовим вход',
];

/** Ожидание кода: заметно дольше прочего — requestQR повторяется до лимита */
export const LONG_WAIT_HINTS_QR: string[] = [
  'Запрашиваем код у канала',
  'Поднимаем подключение — это самая долгая часть',
  'Код появится, как только канал его выпустит',
];

/** Ожидание входа в окне провайдера (ВКонтакте, Instagram) */
export const LONG_WAIT_HINTS_PROVIDER: string[] = [
  'Ждём подтверждения входа',
  'Проверяем ответ провайдера',
  'Если окно входа закрылось — откройте его ещё раз',
];
